// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2ZC1Q","actionsCol":"EnrolledClinics_actionsCol__3krG3"};